import { useMonthFormat } from '@gogame/intl-ts';
import { useScreenMessage } from '@gogame/screens';

import { discardMarketingPlan } from '../sources/marketingPlanning';

export const useDiscardMarketingPlan = () => {
  const { showSuccessMessage, showErrorMessage } = useScreenMessage();
  const monthYearFormat = useMonthFormat();

  return (data) => {
    return discardMarketingPlan(data)
      .then((response) => {
        showSuccessMessage(
          `Marketing Plan ${monthYearFormat({
            year: data?.year,
            month: data?.month,
          })} was discarded`
        );
        return response;
      })
      .catch((e) => {
        showErrorMessage(e.message);
        return Promise.reject(e);
      });
  };
};
